import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Check from '@material-ui/icons/Check';
import styles from 'styles/jss/original/components/menus/detailTool';
import classNames from 'classnames';
import { IMenu } from '@/@types/generated/contentful';

// @ts-expect-error
const useStyles = makeStyles(styles);

type ComponentProps = {
  menu: IMenu;
};

const DetailTool: React.FC<ComponentProps> = ({ menu }) => {
  const { tool } = menu.fields;
  const classes = useStyles();
  const [checked, setChecked] = useState([24, 22]);

  const handleToggle = (value: number) => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setChecked(newChecked);
  };

  if (tool.length === 0) {
    return null;
  }
  return (
    <div className={classes.section}>
      <h4 className={classes.title}>使用する調理器具</h4>
      <hr className={classes.hr} />
      <div className={classNames(classes.checkboxAndRadio, classes.checkboxAndRadioHorizontal)}>
        {tool.map((item) => {
          return (
            <div key={item}>
              <FormControlLabel
                control={
                  <Checkbox
                    tabIndex={-1}
                    onClick={() => handleToggle(21)}
                    checkedIcon={<Check className={classes.checkedIcon} />}
                    icon={<Check className={classes.uncheckedIcon} />}
                    classes={{
                      checked: classes.checked,
                      root: classes.checkRoot
                    }}
                  />
                }
                classes={{ label: classes.label, root: classes.labelRoot }}
                label={item}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DetailTool;
